import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function normalizeChatGPTStyleMarkdown(raw) {
  if (!raw) return "";

  return raw
    .replace(/\r\n|\r/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .replace(/ +\n/g, "\n")
    .replace(/\n +/g, "\n")
    .replace(/^- /gm, "- ")
    .replace(/^(\d+)\. /gm, "$1. ")
    .trim();
}

const formatContent = (text) => {
  const cleaned = normalizeChatGPTStyleMarkdown(text);

  return (
    <div className="text-[15px] leading-[1.5] space-y-1 font-sans text-zinc-800">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {cleaned}
      </ReactMarkdown>
    </div>
  );
};

export default formatContent;